import type { Messages } from "../types";

export const de = {
  "common": {
    "brand": "UN8",
    "brandTag": "Exklusives christliches Dating",
    "continue": "Weitermachen",
    "leave": "Verlassen",
    "leaveForNow": "Gehen Sie für jetzt",
    "yes": "Ja",
    "no": "NEIN",
    "goBack": "Geh zurück",
    "saving": "Sparen…",
    "submitting": "Einreichen…",
    "pleaseWait": "Bitte warten…",
    "ellipsis": "…",
    "male": "Männlich",
    "female": "Weiblich",
    "phases": {
      "gate": "Tor",
      "verify": "Verifizieren",
      "setup": "Aufstellen",
      "profile": "Profil"
    },
    "storageQuota": "Auf diesem Telefon ist nicht mehr genügend Speicherplatz für gespeicherte Antworten vorhanden. Geben Sie etwas Speicherplatz frei und versuchen Sie es dann erneut.",
    "storageDisabled": "Dieser Browser speichert Ihre Antworten nicht. Deaktivieren Sie den privaten Modus oder lassen Sie Site-Daten zu und laden Sie dann neu.",
    "charMeta": "{len}/{min} Min. · {current}/{max}",
    "charMetaMin": "min. {min} Zeichen"
  },
  "welcome": {
    "promise": "Unser Ziel ist es, dass Sie diese App so schnell wie möglich löschen.",
    "sub": "UN8 hilft ernsthaften christlichen Singles, einen Lebenspartner zu finden – und dann zu gehen. Verifiziert. Werte zuerst. Kein endloses Wischen.",
    "signedInAs": "Angemeldet als {email}",
    "liveServer": "· Live-Server",
    "deviceOnly": "· Nur dieses Gerät",
    "migrateOffer": "Dieses Gerät verfügt noch über ein lokales Profil. Laden Sie es auf den gemeinsam genutzten Server hoch, damit andere Telefone Sie nach der Moderation sehen können? Es wird nichts hochgeladen, bis Sie eine Auswahl treffen.",
    "uploadLocalProfile": "Laden Sie mein lokales Profil hoch",
    "keepOnDevice": "Behalten Sie es nur auf diesem Gerät",
    "migrateNeedGender": "Wählen Sie in Ihrem Profil zunächst „Männlich“ oder „Frau“ aus.",
    "migrateDone": "Profiltext hochgeladen. Laden Sie den Ausweis, das Video und die Fotos erneut hoch, damit die Moderation sie überprüfen kann.",
    "deleteConfirm": "Ihr Konto, alle Nachrichten und alle Medien (einschließlich ID und Video) dauerhaft vom Server löschen?",
    "accountDeleted": "Konto gelöscht.",
    "begin": "Beginnen",
    "continueOnboarding": "Setzen Sie das Onboarding fort",
    "logIn": "Einloggen",
    "logOut": "Abmelden",
    "reviewConsole": "Überprüfen Sie die Konsole",
    "matching": "Partnersuche",
    "deleteMyAccount": "Mein Konto löschen"
  },
  "faith": {
    "eyebrow": "Glaubenstor",
    "title": "Ich folge Jesus Christus",
    "text": "UN8 ist für Nachfolger Jesu Christi.",
    "yesTitle": "Ja",
    "yesBody": "",
    "noTitle": "Nein",
    "noBody": "",
    "respectTitle": "Mit Respekt",
    "respectBody": "UN8 ist für eine Community konzipiert und wir möchten lieber ehrlich sein, als Ihre Zeit zu verschwenden. Verwenden Sie „Unten verlassen“ oder „Zurück“, wenn dies nicht Ihr Zuhause ist.",
    "sharedTitle": "Gemeinsames Fundament",
    "sharedBody": "Glaube ist hier kein Etikett. Es ist der Boden, auf dem Sie sich treffen.",
    "hintNotChristian": "UN8 richtet sich an Nachfolger Jesu Christi. Tippe unten auf Verlassen, oder auf Ja, wenn das du bist.",
    "hintUnset": "Tippe auf Ja, um fortzufahren, oder auf Verlassen / Zurück, wenn dies nicht dein Zuhause ist."
  },
  "rules": {
    "eyebrow": "Gemeinschaftsbund",
    "title": "Wie wir miteinander umgehen",
    "text": "Bestätige jede Regel. Alle drei sind erforderlich. Verstöße führen zur dauerhaften Entfernung. Fake-Profile werden für immer gesperrt.",
    "agreeContinue": "Ich stimme zu – fahren Sie fort",
    "respectful": {
      "title": "Seien Sie respektvoll",
      "description": "Sprechen und handeln Sie mit Würde. Jeder Mensch hier ist nach Gottes Bild geschaffen."
    },
    "noSexualContent": {
      "title": "Kein sexueller Inhalt",
      "description": "Keine expliziten Fotos, Nachrichten oder Anfragen. Reinheit ist hier nicht optional."
    },
    "noDominance": {
      "title": "Dominieren oder kontrollieren Sie nicht",
      "description": "Kein Zwang, Manipulation oder Druck. Liebe kontrolliert nicht."
    },
    "hint": "Kreuzen Sie alle drei Versprechen an, bevor Sie fortfahren."
  },
  "intent": {
    "eyebrow": "",
    "title": "Wonach suchst du?",
    "text": "",
    "marriage": {
      "label": "Einen Lebenspartner",
      "description": ""
    },
    "discernment": {
      "label": "Ernsthaft unterscheiden",
      "description": ""
    },
    "notCasual": {
      "label": "Nichts Unverbindliches",
      "description": ""
    },
    "hint": "Wähle eines."
  },
  "account": {
    "eyebrow": "Konto",
    "title": "Erstellen Sie Ihren Zugang",
    "text": "Ihr Handle erstellt eine stabile Benutzer-ID. Bewerbung, Verifizierung, Likes und Übereinstimmungen sind alle an diese ID gebunden. Es wird keine E-Mail gesendet.",
    "recoveryTitle": "Speichern Sie Ihren Wiederherstellungscode",
    "recoveryText": "Einmal gezeigt. Ohne sie kann eine verlorene Passphrase in diesem geschlossenen Test nicht zurückgesetzt werden.",
    "savedContinue": "Ich habe es gespeichert – fahren Sie fort",
    "handle": "Handhaben",
    "handlePlaceholder": "you@example.com oder ein kurzer Handle",
    "passphrase": "Passphrase",
    "passphrasePlaceholder": "Mindestens 8 Zeichen",
    "signedInTitle": "Angemeldet",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Vertrauensstandard",
    "trustBody": "Es ist kein Profil sichtbar, bis die Identitätsüberprüfung abgeschlossen ist und die Moderation Sie genehmigt.",
    "continueToVerification": "Weiter zur Verifizierung",
    "hintEmail": "Geben Sie eine E-Mail-Adresse ein, die @ enthält.",
    "hintPassword": "Wählen Sie ein Passwort mit mindestens 8 Zeichen."
  },
  "verify": {
    "intro": {
      "eyebrow": "Überprüfung",
      "title": "Vertrauen ist das Tor",
      "text": "Laden Sie einen amtlichen Ausweis, ein Bestätigungsvideo und echte Fotos {min}–{max} hoch. Alles gelangt in eine Überprüfungswarteschlange, bevor Ihr Profil angezeigt werden kann.",
      "whyTitle": "Warum wir verifizieren",
      "whyBody": "Welse und Halbwahrheiten haben hier keinen Platz. Fake-Profile werden dauerhaft gesperrt. Medien werden bis zur Genehmigung mit dem Status pending_review gespeichert.",
      "start": "Verifizierung starten"
    },
    "steps": {
      "id": {
        "title": "Regierungsausweis",
        "description": "Reisepass oder Personalausweis – Kamera oder Datei-Upload."
      },
      "video": {
        "title": "Bestätigungsvideo",
        "description": "Eine kurze Aufnahme, die Ihre Anwesenheit beweist."
      },
      "photos": {
        "title": "Echte Fotos",
        "description": "Sieben bis zehn klare Fotos von Ihnen."
      },
      "review": {
        "title": "Integritätsprüfung",
        "description": "Uploads bleiben pending_review, bis das Personal sie bestätigt."
      }
    },
    "id": {
      "eyebrow": "Schritt 1 von 4",
      "title": "Regierungsausweis",
      "text": "Erfassen oder laden Sie Ihren Reisepass oder Personalausweis hoch. Es wird nichts öffentlich gepostet – der Status bleibt pending_review, bis die Mitarbeiter dies bestätigen.",
      "savedTitle": "ID gespeichert",
      "savedBody": "Als nächstes folgt ein kurzes Bestätigungsvideo Ihres Gesichts, dann {min}–{max} echte Fotos von Ihnen. Wird weiterhin entsperrt, wenn diese ID als gespeichert angezeigt wird.",
      "hint": "Machen Sie ein Foto Ihres amtlichen Ausweises oder laden Sie es hoch und warten Sie dann, bis „Gespeichert“ angezeigt wird."
    },
    "video": {
      "eyebrow": "Schritt 2 von 4",
      "title": "Bestätigungsvideo",
      "text": "Nehmen Sie einen kurzen Clip auf oder laden Sie einen hoch. Schauen Sie in die Kamera. Sprechen Sie deutlich. Dies beweist, dass Sie anwesend sind – und keine abgekratzte Galerie.",
      "hint": "Nehmen Sie ein kurzes Bestätigungsvideo auf und warten Sie, bis „Gespeichert“ angezeigt wird."
    },
    "photos": {
      "eyebrow": "Schritt 3 von 4",
      "title": "Echte Fotos",
      "text": "Fügen Sie {min}–10 aktuelle Fotos von sich hinzu. Benutzen Sie die Kamera oder Ihre Bibliothek. Tippen Sie auf ×, um eine Aufnahme zu entfernen.",
      "continueToReview": "Lesen Sie weiter",
      "hint": "Fügen Sie {min} zu 10 klaren Fotos von sich selbst hinzu. Setzen Sie die Entsperrungen fort, wenn sie gespeichert sind."
    },
    "review": {
      "eyebrow": "Schritt 4 von 4",
      "title": "Integritätsprüfung",
      "text": "Medien werden als pending_review{underUser} in die Warteschlange gestellt. Matches und Likes verwenden dieselbe ID.",
      "underUser": "unter dem Benutzer {userId}",
      "governmentId": "Regierungsausweis",
      "confirmationVideo": "Bestätigungsvideo",
      "photos": "Fotos",
      "missing": "Fehlen",
      "filesReady": "{count}-Dateien bereit",
      "submittedTitle": "Zur Überprüfung eingereicht",
      "submittedText": "Die Anwendungs-ID entspricht der Authentifizierungsbenutzer-ID, also genehmigen → Pool und gegenseitige Likes bleiben aufeinander abgestimmt.",
      "submitContinue": "Senden und fortfahren"
    }
  },
  "setup": {
    "eyebrow": "Kontoeinrichtung",
    "title": "Sag die Wahrheit über dich",
    "text": "Diese Antworten passen zusammen und werden in der Überprüfung angezeigt. Sanfte Lügen verschwenden die Zeit aller – auch Ihrer.",
    "beginSetup": "Beginnen Sie mit der Einrichtung",
    "pillars": {
      "faith": {
        "name": "Glaube",
        "text": "Warum du Christus folgst."
      },
      "character": {
        "name": "Charakter",
        "text": "Loyalität, Ehrlichkeit, Leidenschaft, Engagement – ​​bewertet mit 1–10."
      },
      "story": {
        "name": "Geschichte",
        "text": "Wer Sie sind und was Sie suchen."
      },
      "life": {
        "name": "Leben",
        "text": "Hobbys, Lesen und Berufung."
      }
    },
    "whyChristian": {
      "eyebrow": "Glaube",
      "title": "Warum bist du Christ?",
      "text": "Eine kurze, ehrliche Antwort. Keine Predigt – ein Grund, der Ihnen gehört.",
      "label": "Ihre Antwort",
      "placeholder": "z.B. Ich habe Christus in einer Zeit des Verlusts kennengelernt und bin ihm seitdem gefolgt ...",
      "hint": "Schreiben Sie mindestens {min} Zeichen darüber, warum Sie Jesus nachfolgen."
    }
  },
  "scales": {
    "eyebrow": "Charakterskalen",
    "title": "Bewerten Sie sich ehrlich",
    "text": "Loyalität, Ehrlichkeit, Leidenschaft, Engagement – jeweils von 1 bis 10. Geselligkeit ist optional. Das Aufblähen von Zahlen führt später nur zu einer Fehleinschätzung.",
    "loyalty": {
      "label": "Grad der Loyalität",
      "hint": "Seien Sie ehrlich – wie treu stehen Sie denen zur Seite, die Sie lieben?"
    },
    "honesty": {
      "label": "Maß an Ehrlichkeit",
      "hint": "Wie konsequent sagen Sie die volle Wahrheit?"
    },
    "passion": {
      "label": "Wie leidenschaftlich bist du?",
      "hint": "Überzeugung und Tiefe – keine Leistung."
    },
    "commitment": {
      "label": "Grad des Engagements",
      "hint": "Wie bereit sind Sie, etwas zu bauen, das von Dauer ist?"
    },
    "social": {
      "label": "Geselligkeit",
      "hint": "Ruhige Abende an einem Ende. Ein voller Raum am anderen."
    },
    "hint": "Stellen Sie Loyalität, Ehrlichkeit, Leidenschaft und Engagement ein."
  },
  "about": {
    "eyebrow": "Über dich",
    "title": "Beschreiben Sie sich in ein paar Sätzen",
    "text": "Wer du bist, wenn niemand auftritt. Temperament, Rhythmus, worauf es im Alltag ankommt.",
    "label": "Über dich",
    "placeholder": "Ruhige Morgen, ernst mit der Familie, leicht lachen, lieber Tiefe als Lärm …",
    "hint": "Schreiben Sie mindestens {min} Zeichen über sich."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "Wonach suchst du?",
    "text": "Die wichtigsten Charaktereigenschaften, die Sie sich von einem potenziellen Partner wünschen – keine Einkaufsliste mit Looks.",
    "label": "Gewünschte Charaktereigenschaften",
    "placeholder": "z.B. Unerschütterlicher Glaube, emotionale Reife, Freundlichkeit unter Stress …",
    "hint": "Schreiben Sie mindestens {min} Zeichen über den Partner, den Sie sich wünschen."
  },
  "loveReady": {
    "eyebrow": "Schwelle",
    "title": "Sind Sie bereit, die Liebe Ihres Lebens zu treffen?",
    "text": "UN8 existiert, damit ernsthafte Singles einen Partner finden – und dann die App löschen. Nur „Ja“-Entsperrungen werden fortgesetzt.",
    "yesTitle": "Ja – ich bin bereit",
    "yesBody": "Ich bin hier, um meiner Person mit Klarheit und Mut zu begegnen.",
    "noTitle": "Noch nicht",
    "noBody": "Wenn Sie nur surfen, ist diese Community nicht die richtige Wahl.",
    "comeBackTitle": "Kommen Sie zurück, wenn Sie bereit sind",
    "comeBackBody": "UN8 richtet sich an Menschen, die bereit sind, sich zu treffen – und nicht, um Optionen zu sammeln. Verwenden Sie „Verlassen“ unten, wenn Sie vorerst aufhören möchten. Ihre Antworten werden auf diesem Telefon gespeichert.",
    "hintNo": "Es bleibt nur „Ja“. Wenn Sie noch nicht bereit sind, tippen Sie auf „Vorerst verlassen“ – Ihre Antworten bleiben auf diesem Telefon.",
    "hintUnset": "Tippen Sie auf „Ja“, wenn Sie bereit sind, jemanden zum Heiraten zu treffen."
  },
  "lifestyle": {
    "eyebrow": "Lebensstil",
    "title": "Wie du Tag für Tag lebst",
    "text": "Sport, Hobbys, Lesen und Beruf – praktische Signale für echte Vereinbarkeit.",
    "hobbies": "Aktuelle Sportarten oder Hobbys",
    "hobbiesPlaceholder": "Was Sie aktiv tun – nicht das, was Sie früher getan haben.",
    "reading": "Lesen Sie?",
    "readingHint": "1 = fast nie · 10 = täglich, intensiv lesen",
    "profession": "Beruf / Branche",
    "professionPlaceholder": "z.B. Krankenpflege · Software · Bildung · Handwerk",
    "hintHobbies": "Nennen Sie mindestens eine Sportart oder ein Hobby, das Sie tatsächlich ausüben.",
    "hintReading": "Folie „Lesen Sie?“ Es wird also eine Zahl von 1 bis 10 angezeigt.",
    "hintProfession": "Geben Sie Ihre Arbeit ein, sogar ein kurzes Wort."
  },
  "faithDepth": {
    "eyebrow": "Passend · Glaube",
    "title": "Wie zentral ist Ihr Glaube?",
    "text": "Gott dienen – wie wichtig ist es in Ihrem Leben? Antworten Sie ehrlich. Beim Matching wird dies für die Tiefe und nicht für die Leistung verwendet.",
    "serving": "Gott dienen – wichtig",
    "servingHint": "10 % … 100 %. Schieben Sie in 10er-Schritten.",
    "keepsCommandments": "Halten Sie die Gebote?",
    "grewUpInChurch": "Sind Sie in der Kirche aufgewachsen?",
    "churchAttendance": "Kirchenbesuch",
    "frequent": {
      "label": "Häufig",
      "hint": "Regelmäßige Zusammenkunft mit dem Leib Christi."
    },
    "seldom": {
      "label": "Selten",
      "hint": "Gelegentlich kein wöchentlicher Rhythmus."
    },
    "never": {
      "label": "Niemals",
      "hint": "Derzeit nicht anwesend."
    },
    "spreadsGospel": "Verbreiten Sie das Evangelium?",
    "hasIdols": "Hast du Idole?",
    "hintServing": "Schieben Sie, wie wichtig es ist, Gott in Ihrem Leben zu dienen.",
    "hintCommandments": "Antworten Sie, ob Sie die Gebote halten – Ja oder Nein.",
    "hintGrewUp": "Antworten Sie, ob Sie in der Kirche aufgewachsen sind: Ja oder Nein.",
    "hintAttendance": "Wählen Sie, wie oft Sie in die Kirche gehen.",
    "hintGospel": "Antworten Sie, ob Sie das Evangelium teilen: Ja oder Nein.",
    "hintIdols": "Antworten Sie, ob Sie Idole haben: Ja oder Nein."
  },
  "character": {
    "eyebrow": "Passender · Charakter",
    "title": "Wer du zu Hause bist",
    "text": "Charakter für die Werbung – Frieden stiftend, Manieren, Ehrlichkeit. Das Aufblähen von Antworten führt später nur zu falschen Ergebnissen.",
    "peacemaker": "Sind Sie ein Friedensstifter?",
    "homebuilder": "Sind Sie ein Hausbauer?",
    "humorous": "Bist du humorvoll?",
    "caring": "Fürsorglich und liebevoll?",
    "peacefulHome": "Möchten Sie ein friedliches Zuhause – frei von Kämpfen?",
    "manners": "Gute Manieren?",
    "honestyRating": "Ehrlichkeitsbewertung in diesem Fragebogen",
    "honestyHint": "1–10 – Wie ehrlich antworten Sie?",
    "hintPeacemaker": "Beantworten Sie jede Frage mit „Ja“ oder „Nein“ und beginnen Sie mit „Friedensstifter“.",
    "hintHomebuilder": "Beantworten Sie, ob Sie ein Hausbauer sind.",
    "hintHumorous": "Antworten Sie, ob Sie humorvoll sind.",
    "hintCaring": "Antworten Sie, ob Sie fürsorglich und liebevoll sind.",
    "hintPeaceful": "Beantworten Sie, ob Sie ein ruhiges Zuhause wünschen.",
    "hintManners": "Beantworten Sie, ob Sie gute Manieren haben.",
    "hintHonesty": "Schieben Sie Ihre Ehrlichkeitsbewertung von 1 auf 10."
  },
  "history": {
    "eyebrow": "Matching · Geschichte",
    "title": "Vergangenheit und Bereitschaft",
    "text": "Substanzen, Kindheit, Narben und ob Sie für eine dauerhafte Beziehung bereit sind. Die Wahrheit hier schützt euch beide.",
    "marijuana": "Haben Sie Marihuana konsumiert?",
    "lsd": "Haben Sie LSD verwendet?",
    "otherDrugs": "Haben Sie andere Medikamente eingenommen?",
    "addicted": "Waren Sie süchtig?",
    "childhood": "Stabile, liebevolle Kindheit?",
    "scars": "Irgendwelche Narben/Beschädigungen?",
    "lasting": "Bereit für eine dauerhafte Beziehung?",
    "hintStart": "Beantworten Sie auf dieser Seite alle Fragen mit „Ja“ oder „Nein“, beginnend oben.",
    "hintLsd": "Beantworten Sie die LSD-Frage: Ja oder Nein.",
    "hintOtherDrugs": "Antworten Sie, ob Sie andere Medikamente eingenommen haben.",
    "hintAddicted": "Antworten Sie, ob Sie süchtig waren.",
    "hintChildhood": "Beantworten Sie, ob Ihre Kindheit stabil und liebevoll war.",
    "hintScars": "Beantworten Sie, ob Sie Narben tragen.",
    "hintLasting": "Beantworten Sie, ob Sie für eine dauerhafte Beziehung bereit sind."
  },
  "appearance": {
    "eyebrow": "Passend · Aussehen",
    "title": "Tätowierungen",
    "text": "Ihre Tätowierungen und ob Tätowierungen an einem Partner für Sie akzeptabel sind.",
    "hasTattoos": "Hast du Tätowierungen?",
    "acceptsPartner": "Tätowierungen bei einem Partner akzeptieren?",
    "hintHas": "Sagen Sie, ob Sie Tätowierungen haben – Ja oder Nein.",
    "hintAccepts": "Sagen Sie, ob Tätowierungen an Ihrem Partner für Sie akzeptabel sind."
  },
  "home": {
    "eyebrow": "Matching · Haus & Grundstück",
    "title": "Land, Fähigkeiten, Selbstversorgung",
    "text": "Kräuter, Nahrungsmittelanbau, Obstwald, Zubereitung, gemeinschaftliche Landwirtschaft, Konservieren, Überleben – und alle besonderen Fähigkeiten.",
    "herbKnowledge": "Kräuterwissen?",
    "plantOwn": "Pflanzen Sie Ihr eigenes Obst und Gemüse an?",
    "fruitForest": "Interessiert an einem Obstwald?",
    "prepping": "Bereiten Sie sich auf Katastrophen vor?",
    "communityFarming": "Gemeinschaftslandwirtschaft / unabhängiges Leben?",
    "canning": "Einmachen und Konservieren?",
    "survival": "Überlebensfähigkeiten?",
    "specialSkills": "Besondere Fähigkeiten (optional)",
    "specialPlaceholder": "Alles andere, was Sie in einen Haushalt oder ein Grundstück mitbringen …",
    "hintStart": "Beantworten Sie alle Fragen zu Land und Fertigkeiten mit „Ja“ oder „Nein“, beginnend ganz oben.",
    "hintPlant": "Beantworten Sie, ob Sie Ihr eigenes Obst und Gemüse anbauen.",
    "hintFruitForest": "Beantworten Sie, ob Sie ein Obstwald interessiert.",
    "hintPrepping": "Beantworten Sie, ob Sie auf Katastrophen vorbereitet sind.",
    "hintCommunity": "Beantworten Sie, ob Sie an gemeinschaftlicher Landwirtschaft interessiert sind.",
    "hintCanning": "Beantworten Sie, ob Sie Lebensmittel konservieren können.",
    "hintSurvival": "Beantworten Sie, ob Sie über Überlebensfähigkeiten verfügen."
  },
  "family": {
    "eyebrow": "Passend · Familie",
    "title": "Kinder, Glaubenstiefe, Substanzen",
    "text": "Was Sie von einem Partner in Bezug auf Glaubensintensität, Kinder und früheren Substanzkonsum brauchen.",
    "children": "Kinder",
    "wants": {
      "label": "Will Kinder",
      "hint": "Eine Familie zu gründen ist Teil der Vision."
    },
    "doesNotWant": {
      "label": "Will keine Kinder",
      "hint": "Klares Nein zu Kindern."
    },
    "open": {
      "label": "Offen",
      "hint": "Anspruchsvoll – in keiner Weise verschlossen."
    },
    "hasLivingWith": {
      "label": "Hat Kinder und lebt mit ihnen zusammen",
      "hint": "Kinder gehören bereits zum täglichen Leben."
    },
    "requiredFaith": "Mindestglaube, die Sie an einen Partner benötigen",
    "requiredFaithHint": "10 % … 100 %. Hartes Tor, wenn beide Seiten geantwortet haben.",
    "acceptsSubstances": "Früheren Substanzkonsum bei einem Partner akzeptieren?",
    "hintChildren": "Wählen Sie eine Karte über Kinder.",
    "hintFaith": "Schieben Sie das Mindestglaubensniveau, das Sie sich von einem Partner erhoffen.",
    "hintSubstances": "Sagen Sie, ob früherer Substanzkonsum bei einem Partner akzeptabel ist."
  },
  "ancestry": {
    "eyebrow": "Passender · Hintergrund",
    "title": "Hintergrundeinstellungen",
    "text": "Teilen Sie Ihren Hintergrund und Ihre Offenheit gegenüber einem Partner mit. Dies prägt lediglich die Rangfolge – es verbirgt niemals jemanden vor dem Deck.",
    "yourBackground": "Ihr Hintergrund (alles Zutreffende auswählen)",
    "openToPartner": "Offen für einen Partner",
    "codeDesc": "Code: {code}",
    "anyDesc": "Stärkste Präferenz für Breite – empfohlen, wenn Sie unsicher sind.",
    "preferenceOnly": "Nur Präferenz – kein Tor.",
    "hintOwn": "Kreuzen Sie mindestens einen Hintergrund an, der Sie beschreibt. Das hilft nur beim Ranking – es verbirgt niemanden.",
    "hintAccepted": "Kreuzen Sie an, wofür Sie bei einem Partner offen sind, oder „Offen – egal“."
  },
  "interests": {
    "eyebrow": "Passende · Interessen",
    "title": "Was Ihnen Spaß macht",
    "text": "Wählen Sie mindestens eine aus. Überlappung hilft beim Ranking; Schweigen wird niemals bestraft.",
    "hint": "Kreuzen Sie mindestens ein Interesse an."
  },
  "reflection": {
    "eyebrow": "Matching · Reflexion",
    "title": "In deinen eigenen Worten",
    "text": "Diese vier Antworten werden vollständig angezeigt und nie bewertet. Schreiben Sie, was wahr ist.",
    "describeYourself": "Beschreibe dich",
    "lifePurpose": "Lebenszweck",
    "fifteenYear": "Du und die Liebe deines Lebens in 15 Jahren",
    "weaknesses": "Schwächen",
    "hintDescribe": "Beschreiben Sie sich mit mindestens {min} Zeichen.",
    "hintPurpose": "Schreiben Sie Ihren Lebenszweck in mindestens {min} Zeichen.",
    "hintVision": "Schreiben Sie die 15-Jahres-Vision in mindestens {min} Zeichen.",
    "hintWeaknesses": "Nennen Sie eine Schwachstelle in mindestens {min} Zeichen."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Ein paar wesentliche Dinge",
    "text": "Halten Sie es einfach. Zur eindeutigen Zuordnung ist das Geschlecht hier binär – männlich oder weiblich.",
    "firstName": "Vorname",
    "firstNamePlaceholder": "Wie Sie bekannt sein möchten",
    "age": "Alter",
    "agePlaceholder": "18+",
    "city": "Stadt",
    "cityPlaceholder": "Wo Sie ansässig sind",
    "sex": "Geschlecht",
    "maleBody": "Ich bin ein Mann.",
    "femaleBody": "Ich bin eine Frau.",
    "hintName": "Geben Sie Ihren Vornamen ein (mindestens zwei Buchstaben).",
    "hintAge": "Das Alter muss 18 Jahre oder älter sein.",
    "hintCity": "Geben Sie die Stadt ein, in der Sie leben.",
    "hintGender": "Wählen Sie „Männlich“ oder „Frau“, damit die Zuordnung funktioniert."
  },
  "ready": {
    "title": "Sie dürfen eintreten.",
    "textNamed": "{name}, Ihre Überprüfung und Einrichtung werden aufgezeichnet. Medien sind pending_review. Willkommen bei UN8 – finden Sie Ihre Person und löschen Sie dann die App.",
    "text": "Ihre Verifizierung und Einrichtung werden aufgezeichnet. Medien sind pending_review. Willkommen bei UN8 – finden Sie Ihre Person und löschen Sie dann die App.",
    "summaryAria": "Setup-Zusammenfassung",
    "christianRules": "Christliche · Regeln bekräftigt",
    "mediaLine": "ID · Video · {photoCount} Fotos · Warteschlange {pending}",
    "scalesLine": "Skalen L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Geschlecht —",
    "professionFallback": "Beruf",
    "userLine": "Benutzer {userId}",
    "enterMatching": "Geben Sie Matching ein",
    "needGender": "Gehen Sie zurück zum Profilschritt und wählen Sie „Männlich“ oder „Frau“ und versuchen Sie es dann erneut."
  },
  "match": {
    "brandTag": "Partnersuche",
    "navOnboarding": "Einrichtung",
    "navReview": "Moderation",
    "navMatching": "Partnersuche",
    "logOut": "Abmelden",
    "quietSignIn": "Anmelden",
    "enterTitle": "Geben Sie Matching ein",
    "enterText": "Melden Sie sich mit derselben E-Mail-Adresse wie beim Onboarding an. Anwendung, Pool, Likes und Matches verwenden alle Ihre stabile Benutzer-ID.",
    "email": "E-Mail",
    "emailPlaceholder": "du@beispiel.com",
    "password": "Passwort",
    "passwordPlaceholder": "Ihr Passwort",
    "logIn": "Einloggen",
    "guestOr": "Oder versuchen Sie es mit einer Gastsitzung (stabile ID pro Browser · nur Demo)",
    "guestMan": "Gast als Mann",
    "guestWoman": "Gast als Frau",
    "goOnboarding": "Gehen Sie zu Onboarding →",
    "guestSession": "Gastsitzung · Demo-Auswahl",
    "man": "Mann",
    "woman": "Frau",
    "tabToday": "Auswahl",
    "tabMatches": "Übereinstimmungen ({count})",
    "yourMatches": "Deine Streichhölzer",
    "matchesSub": "Anhaltendes gegenseitiges Interesse · {count} ausgehende {likesWord}",
    "like": "Like",
    "likes": "Likes",
    "emptyMatches": "Noch kein gegenseitiges Interesse. Unterscheide weiter die Auswahl dieser Woche.",
    "valuesScore": "Werte {score}",
    "chatOpen": "· Chat geöffnet",
    "tapToChat": "· Tippen Sie zum Chatten",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Werte {score}",
    "noProfileYet": "Noch kein Profil",
    "noProfileText": "Beenden Sie das Onboarding oder tippen Sie oben auf „Onboarding“ und dann auf „Starten“. Die Gastzuordnung erfolgt auf dem Eingabebildschirm, wenn Sie nur schauen möchten.",
    "matchingPaused": "Abgleich pausiert",
    "noOneYet": "Noch niemand zu zeigen",
    "todaysSetDone": "Das ist die Auswahl dieser Woche",
    "weeklyTitle": "Ihre 4 für diese Woche",
    "weeklyTitleCount": "Ihre {count} für diese Woche",
    "weeklyCountdown": "Nächste Auswahl in {days} Tagen",
    "weeklyCountdownOne": "Nächste Auswahl in 1 Tag",
    "weeklyCountdownSoon": "Nächste Auswahl bald",
    "shortWeekCopy": "Diese Woche gibt es {count}. Wir schlagen niemanden vor, der nicht passt.",
    "shortWeekTwo": "Diese Woche gibt es zwei. Wir schlagen niemanden vor, der nicht passt.",
    "weekDone": "Das ist die Auswahl dieser Woche",
    "weekDoneText": "Sie haben alle durchgesehen, die wir ehrlich vorschlagen konnten. Kommen Sie zur nächsten Auswahl zurück.",
    "emptyNeverHad": "In der Liste dieser Woche steht noch niemand. Der Pool füllt sich — öffnen Sie die Auswahl gleich erneut, oder kommen Sie wieder, wenn weitere Mitglieder freigegeben sind.",
    "emptyDone": "Sie haben die Auswahl dieser Woche gesehen. Kommen Sie zur nächsten Freigabe zurück, oder setzen Sie die Auswahl zurück.",
    "likesMayNotStick": "Likes bleiben möglicherweise nicht hängen.",
    "poolMeta": "Auswahl: {pool} · Matches: {matches} · Likes: {liked}",
    "demoPool": "Demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Auswahl zurücksetzen",
    "backOnboarding": "Zurück zum Onboarding",
    "feedEyebrowDemo": "Wochenauswahl · Demo",
    "feedEyebrowLive": "Wochenauswahl · Pool ({source}, {count})",
    "feedTitle": "Unterscheiden Sie sorgfältig",
    "left": "noch {count}",
    "pass": "Passieren",
    "interested": "Interessiert",
    "likeHeart": "Like geben",
    "flame": "Flame geben",
    "flameNoneLeft": "Diese Woche keine Flamme mehr. Am Montag kommt sie zurück.",
    "flameLead": "Gib {name} eine Flame.",
    "flameOnly": "Nur Flamme",
    "flameSend": "Flame senden",
    "flameBurstTitle": "Eine Flamme für {name}",
    "flameSent": "Du hast {name} eine Flamme geschickt.",
    "flipNeedsLike": "Gib ein Like, um die Karte zu drehen.",
    "likedStays": "Ein Like bleibt. Du kannst es nicht zurücknehmen.",
    "composeCancel": "Abbrechen",
    "heartsNoneLeft": "Diese Woche keine Herzen mehr. Am Montag bekommst du neue.",
    "commentLead": "Gib {name} ein Like.",
    "commentPlaceholder": "33 Buchstaben, nicht mehr",
    "commentCount": "{count} / {max}",
    "commentSend": "Like senden",
    "heartOnly": "Nur Herz",
    "commentTooLong": "Das sind mehr als {max} Buchstaben. Das Herz ging raus; die Notiz nicht.",
    "commentAnchors": {
      "about": "Über mich",
      "lookingFor": "Ich suche",
      "hobbies": "Interessen",
      "photo": "Foto"
    },
    "inboundTitle": "Hat dich geliked",
    "likeBack": "Zurückliken",
    "cardStatLoyalty": "LOY",
    "cardStatHonesty": "HON",
    "cardStatPassion": "PAS",
    "cardStatCommit": "COM",
    "cardStatSocial": "SOC",
    "cardStatFaith": "GLA",
    "cardStatCharacter": "CHA",
    "cardStatPurpose": "ZWE",
    "cardStatHome": "HEI",
    "cardStatAncestry": "HER",
    "cardStatTemper": "TEM",
    "goToProfile": "Zum Profil",
    "goToProfileChat": "Profil & Chat",
    "holdToPeek": "{name}s Karte halten für Werte",
    "holdOrOpenProfile": "Halten für Werte, tippen für {name}s Profil",
    "likeToOpenProfile": "Liken, um das volle Profil zu öffnen",
    "waitLikeBack": "Warten, bis {name} zurückliket — dann öffnet der Chat.",
    "flipToStats": "{name}s Werte zeigen",
    "flipToPhoto": "{name}s Foto zeigen",
    "likeToFlip": "Halten für Werte. Liken fürs volle Profil.",
    "swipeHint": "Ein Pass wird innerhalb von 24 Stunden ersetzt, wenn jemand anderes passt. Wir füllen nie mit einem schlechten Match auf.",
    "celebrationEyebrow": "Gegenseitiges Interesse",
    "celebrationTitle": "Du hast gepasst",
    "celebrationText": "{self} · {other}",
    "celebrationNote": "",
    "openChat": "Chat öffnen",
    "keepDiscerning": "Seien Sie weiterhin kritisch",
    "cardSeeking": "Ich suche",
    "matchingScore": "Matching-Score",
    "affinity": "Matching-Score",
    "valuesScoreLabel": "Matching-Score",
    "cardHobbies": "Hobbys",
    "scoreStrong": "Starke Ausrichtung",
    "scoreSolid": "Solide Ausrichtung",
    "scoreModerate": "Mäßige Ausrichtung",
    "scoreDifferent": "Verschiedene Rhythmen",
    "characterAxisFoot": "Die Charakterachse umfasst die vier Säulen",
    "youThem": "Sie {self} · Sie {other}",
    "stampInterest": "Interesse",
    "stampPass": "Passieren",
    "explainLegacyClose": "Ihre Wertwerte liegen nahe beieinander ({score} von 100).",
    "explainLegacyFuller": "Ein ausführlicheres „Warum“ erscheint, nachdem Sie beide die passenden Fragen beantwortet haben.",
    "explainFaith": "Ihre Glaubensintensität ist vergleichbar – Sie nehmen die Nachfolge Jesu mit ähnlicher Ernsthaftigkeit wahr.",
    "explainCharacter": "Wie Sie die Menschen zu Hause behandeln, stimmt überein – Frieden, Manieren und Fürsorge.",
    "explainPurpose": "Sie bewerten Ihre eigene Ehrlichkeit ähnlich, was ein Zeichen gemeinsamer Ernsthaftigkeit ist.",
    "explainHome": "Sie haben ein gemeinsames Interesse an Land, dem Anbau von Nahrungsmitteln oder einem autarken Zuhause.",
    "explainAncestry": "Sie bevorzugen beide einen ähnlichen familiären Hintergrund. Das ist eine Präferenz, kein Filter – niemand bleibt dafür verborgen.",
    "explainTemperament": "Ihre Interessen und Ihr Temperament überschneiden sich.",
    "explainFallback": "Möglicherweise stimmen die von Ihnen beiden eingegebenen Antworten überein.",
    "explainOverall": "Matching-Score {score}/100",
    "affinityAxes": {
      "faith": "Glaubensintensität",
      "character": "Charakter und Verhalten",
      "purpose": "Ausrichtung des Lebenszwecks",
      "home": "Zuhause & Selbstversorgung",
      "ancestry": "Kultur- und Hintergrundaffinität",
      "temperament": "Temperamentpassung"
    },
    "scaleAxes": {
      "loyalty": "Loyalität",
      "honesty": "Ehrlichkeit",
      "passion": "Hingabe",
      "commitment": "Engagement"
    },
    "waitingModeration": "Ihr Profil wartet auf Freigabe durch die Moderation, bevor die Auswahl öffnet.",
    "completeProfileFirst": "Schließen Sie zuerst Ihr Profil ab und reichen Sie es ein.",
    "moderationDemoNote": "Wir zeigen Demo-Personen, damit Sie Matching schon ausprobieren können.",
    "navSelection": "Auswahl",
    "navWhoLiked": "Mag dich",
    "navMessages": "Nachrichten",
    "navProfile": "Profil",
    "packTitle": "Ihre vier",
    "packSkip": "Tippen zum Fortfahren",
    "refreshTitle": "Neue Auswahl",
    "newSelection": "Neue Auswahl",
    "backToFour": "← Zurück zu Ihren vieren",
    "whoLikedTitle": "Sieh, wer dich mag",
    "whoLikedHint":
      "Like zurück — dann seid ihr ein Match. Chat ist danach länger als dreiunddreißig Buchstaben.",
    "whoLikedEmpty": "Noch niemand Neues hat dich geliked.",
    "whoLikedLocked": "Abonnieren, um Namen in der Wochenauswahl zu sehen — eingehende Herzen stehen weiter unter Nachrichten.",
    "verify": {
      "brandTag": "Verifizieren",
      "title": "Verifiziere dich zum Schreiben",
      "sub": "Schauen und Herzen kann jeder. Für ein Gespräch brauchen wir deinen Ausweis und ein kurzes Bestätigungsvideo. Eingereicht genügt — die Prüfung kann warten.",
      "cta": "Ausweis und Video hinzufügen",
      "videoCta": "Bestätigungsvideo hinzufügen",
      "submitted": "Ausweis und Video sind da. Du kannst schreiben, während wir prüfen.",
      "done": "Du bist verifiziert.",
      "back": "Zurück",
      "continue": "Weiter",
      "idEyebrow": "Identität",
      "videoEyebrow": "Präsenz",
      "idText": "Reisepass oder Personalausweis. Nichts davon wird öffentlich gezeigt. Eingereicht genügt zum Schreiben.",
      "videoText": "Ein kurzer Clip (etwa {seconds} Sekunden). Schau in die Kamera. Das zeigt, dass du wirklich da bist."
    }
  },
  "chat": {
    "brandTag": "Chatten",
    "unavailableTitle": "Chat nicht verfügbar",
    "unavailableText": "Diese Übereinstimmung fehlt oder gehört nicht zu Ihrer Sitzung.",
    "backToMatches": "Zurück zu den Übereinstimmungen",
    "backMatches": "← Übereinstimmungen",
    "valuesSubscriber": "Werte {score} · Abonnent",
    "valuesTrial": "Werte {score} · Testversion",
    "valuesKept": "Werte {score} · Übereinstimmung beibehalten",
    "empty": "Begrüßen Sie mit Bedacht. Im gemeinsamen Backend werden Nachrichten nach einer gegenseitigen Übereinstimmung auf beiden Telefonen synchronisiert.",
    "placeholder": "Nachricht {name}…",
    "ariaMessage": "Nachricht",
    "send": "Schicken"
  },
  "billing": {
    "paywallCopy": "Behalten Sie nach Ihrer kostenlosen Testversion alle, mit denen Sie bereits gematcht haben, und chatten Sie weiter. Um neue Leute zu sehen, abonnieren Sie.",
    "signInToMatch": "Melden Sie sich an, um den Abgleich zu nutzen.",
    "signInFirst": "Melden Sie sich zuerst an.",
    "subscriberUntil": "Abonnent · bis {date}",
    "renewal": "Erneuerung",
    "freeTrial": "Kostenlose Testversion · {days} Tage (endet {date})",
    "soon": "bald",
    "trialEnded": "Testversion beendet · Matches und Chat bleiben geöffnet",
    "subscribe": "Abonnieren · ${price}/Monat",
    "subscribeEarly": "Frühzeitig abonnieren · ${price}/Monat",
    "activeNote": "Abonnement aktiv – Sie können neue Leute wieder sehen.",
    "playOnly": "Abonnement nur über Google Play Billing (App-Installation). Hier gibt es keinen Web-Checkout.",
    "playOnlyShort": "Abrechnung nur über Google Play — keine Web-Zahlung."
  },
  "auth": {
    "recoveryTitle": "Speichern Sie Ihren Wiederherstellungscode",
    "recoveryText": "Schreiben Sie das jetzt auf. Es wird einmal angezeigt. Wenn Sie Ihre Passphrase verlieren, ist dieser Code die einzige Möglichkeit, sie im geschlossenen Test zurückzusetzen.",
    "savedContinue": "Ich habe es gespeichert – fahren Sie fort",
    "welcomeBack": "Willkommen zurück",
    "createAccount": "Erstellen Sie Ihr Konto",
    "intro": "Handle und Passphrase. Es wird keine E-Mail oder SMS versendet. Ihre ID bleibt während des Onboardings, der Überprüfung und des Abgleichs stabil.",
    "tabLogin": "Einloggen",
    "tabRegister": "Registrieren",
    "handle": "Handhaben",
    "handlePlaceholder": "you@example.com oder ein kurzer Handle",
    "passphrase": "Passphrase",
    "passphrasePlaceholder": "Mindestens 8 Zeichen",
    "submitLogin": "Einloggen",
    "submitRegister": "Benutzerkonto erstellen",
    "backWelcome": "Zurück zur Begrüßung"
  },
  "options": {
    "origin": {
      "african": "afrikanisch",
      "european": "europäisch",
      "asian": "asiatisch",
      "latino": "Latino / Hispanoamerikaner",
      "middleEastern": "Naher Osten",
      "indigenous": "Einheimisch",
      "mixed": "Gemischt",
      "other": "Andere",
      "dutch": "Niederländisch",
      "german": "Deutsch",
      "any": "Offen – egal"
    },
    "interest": {
      "prayer": "Gebet",
      "worship": "Verehrung",
      "reading": "Lektüre",
      "hiking": "Wandern",
      "music": "Musik",
      "cooking": "Kochen",
      "farming": "Landwirtschaft / Gartenarbeit",
      "sports": "Sport",
      "missions": "Missionen",
      "family": "Familienleben",
      "crafts": "Kunsthandwerk",
      "outdoors": "Draußen"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Ja",
      "no": "NEIN"
    },
    "id": {
      "titleEmpty": "Regierungsausweis",
      "titleReady": "Ausweis bereit",
      "hintEmpty": "Reisepass oder Personalausweis. Machen Sie ein Live-Foto oder wählen Sie ein Bild/PDF aus. Alle vier Ecken sichtbar.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": "· gespeichert",
      "previewAlt": "Vorschau des Regierungsausweises",
      "pdfAria": "PDF-Dokument ausgewählt",
      "takePhoto": "Machen Sie ein Foto",
      "retake": "Wiederholung",
      "chooseFile": "Datei auswählen",
      "replaceFile": "Datei ersetzen",
      "remove": "Entfernen",
      "uploading": "Hochladen…",
      "cameraTitle": "Fotografieren Sie Ihren Ausweis",
      "signIn": "Melden Sie sich an, bevor Sie Ihre ID hochladen.",
      "uploadFailed": "Der Upload ist fehlgeschlagen. Versuchen Sie es erneut.",
      "badFile": "Diese Datei konnte nicht verwendet werden."
    },
    "video": {
      "titleEmpty": "Bestätigungsvideo",
      "titleLive": "Kamera live",
      "titleReady": "Video fertig",
      "hintEmpty": "Sagen Sie Ihren Vornamen und dass Sie UN8 ehrlich beitreten. 5–15 Sekunden.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Aufzeichnen",
      "cameraUpload": "Kamera-Upload",
      "chooseFile": "Datei auswählen",
      "startRecording": "Starten Sie die Aufnahme",
      "cancel": "Stornieren",
      "stopSave": "Stoppen und speichern",
      "recordAgain": "Nochmals aufnehmen",
      "replaceFile": "Datei ersetzen",
      "remove": "Entfernen",
      "unsupported": "Eine Live-Aufzeichnung ist hier nicht verfügbar. Verwenden Sie den Kamera-Upload oder wählen Sie eine Datei aus.",
      "permissionDenied": "Kameraberechtigung verweigert. Sie können weiterhin eine kurze Videodatei hochladen.",
      "signIn": "Melden Sie sich an, bevor Sie ein Video hochladen.",
      "uploadFailed": "Der Upload ist fehlgeschlagen. Versuchen Sie es erneut.",
      "saveFailed": "Die Aufnahme konnte nicht gespeichert werden.",
      "badVideo": "Dieses Video konnte nicht verwendet werden."
    },
    "photos": {
      "count": "{count} / {max} Fotos",
      "minimumMet": "Minimum erfüllt",
      "moreRequired": "{n} mehr erforderlich",
      "listAria": "Verifizierungsfotos",
      "photoAlt": "Foto {n}",
      "removeAria": "Foto entfernen {n}",
      "camera": "Kamera",
      "takePhoto": "Machen Sie ein Foto",
      "chooseFiles": "Wählen Sie Dateien aus",
      "uploading": "Hochladen…",
      "hint": "Foto aufnehmen öffnet die Live-Kamera. „Dateien auswählen“ ist nur für Galerieauswahlen geeignet. Klare Gesichtsaufnahmen – keine Filter, die die Identität verbergen. Max {max}.",
      "cameraTitle": "Machen Sie ein Foto von sich",
      "signIn": "Melden Sie sich an, bevor Sie Fotos hochladen.",
      "someFailed": "Einige Fotos konnten nicht hochgeladen werden. Versuchen Sie es erneut mit den fehlgeschlagenen Versuchen.",
      "addFailed": "Fotos konnten nicht hinzugefügt werden."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Schließen",
      "capture": "Erfassen",
      "cancel": "Stornieren",
      "hint": "Bleiben Sie ruhig. Die Live-Kamera bleibt geöffnet, bis Sie eine Aufnahme machen.",
      "unavailable": "Die Kamera ist in diesem Browser nicht verfügbar. Verwenden Sie stattdessen Datei auswählen.",
      "permissionDenied": "Kameraberechtigung verweigert oder nicht verfügbar. Verwenden Sie stattdessen Datei auswählen.",
      "frameFailed": "Dieses Bild konnte nicht erfasst werden.",
      "saveFailed": "Das Foto konnte nicht gespeichert werden."
    },
    "uploadStatus": {
      "uploading": "Hochladen…",
      "failed": "Hochladen fehlgeschlagen",
      "savedLocally": "lokal gespeichert",
      "uploaded": "hochgeladen",
      "stored": "gelagert",
      "awaitingUpload": "Warten auf Upload",
      "localFallbackNote": "{error} Datei wird auf diesem Gerät gespeichert; Versuchen Sie es erneut, wenn der Signierungsendpunkt aktiv ist."
    }
  },
  "language": {
    "label": "Sprache",
    "choose": "Sprache wählen"
  },
  "shell": {
    "back": "Zurück",
    "goBackAria": "Geh zurück"
  },
  "questionnaire": {
    "skipForNow": "Vorerst überspringen",
    "skipConsequence": "Ausgefüllte Profile werden zuerst angezeigt.",
    "confirm": "Weiter",
    "progressLabel": "{current} von {total}",
    "fewSentences": "Einige Sätze",
    "ancestryNote": "Dies ist eine Präferenz, die nur das Ranking beeinflusst — niemand wird ausgeblendet."
  }
} as Messages;
